<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
    alt="Stampnexa"
  />
  <svg
    v-else
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="3.5" fill="#125c4f" />
    <path
      d="M4.5 4h7v3c0 2.2-1.5 4.1-3.5 4.6-2-0.5-3.5-2.4-3.5-4.6V4Z"
      fill="#fffdf8"
    />
    <circle cx="8" cy="4" r="1.3" fill="#f1b84b" />
  </svg>
</template>
